import React, { useEffect, useContext } from 'react';
import { ResponseErrorBodyOldUser } from '../types';
import AgreementsWizard from './AgreementsWizard';
import { useTranslation } from 'react-i18next';
import { SettingsContext, GlobalErrorContext } from '../context';
import OldUserForm from './OldUserForm';
import { redirect } from '../lib/Utils';

export default function(props: { error: ResponseErrorBodyOldUser }) {
  const { t } = useTranslation();
  const { setLayoutWidth } = useContext(SettingsContext);
  const { setGlobalError } = useContext(GlobalErrorContext);

  useEffect(() => {
    setLayoutWidth('lg');
  }, [setLayoutWidth]);

  return (
    <AgreementsWizard
      text={t('errorOldUser')}
      agreementsUnsigned={['privacy_policy_v1', 'terms_of_use_v1']}
      steps={[
        {
          content: (
            <OldUserForm
              handleSuccess={() => redirect('/auth')}
              handleFailure={() => setGlobalError(t('agreementError'))}
              agreements={['privacy_policy_v1', 'terms_of_use_v1']}
              buttonText={t('oldUserWizardFinal')}
              userId={props.error.data.userId}
              email={props.error.data.email}
            />
          ),
          isNextDisabled() {
            return true;
          }
        }
      ]}
    />
  );
}
